<template>
  <div class="radio-group">
    <RadioButton
      v-for="option of options"
      :key="option"
      :value="option"
      :model="modelValue"
      @setValue="setValue"
    />
  </div>
</template>

<script>
import RadioButton from './RadioButton'

export default {
  name: 'RadioGroup',
  components: {
    RadioButton
  },
  props: {
    label: {
      type: String,
      required: false
    },
    model: {
      type: String,
      required: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: String
    }
  },
  data() {
    return {
      modelValue: this.model
    }
  },
  methods: {
    setValue(value) {
      this.modelValue = value
      this.$emit('setValue', this.modelValue)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/styles/mixin';

.radio-group {
  @include flex(row, flex-start, center);
  padding-bottom: 10px;
  padding-left: 3px;

  @media(min-width: 600px) {
    margin-top: 4px;
    padding-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form-elements/radio/RadioGroup.vue